import config from './config';

export function getApiBaseAddress() {
  return process.env.NODE_ENV === 'production'
    ? // eslint-disable-next-line no-restricted-globals
      `${location.origin}${config.apiUrl}`
    : config.apiUrl;
}
